import butterflyLogoSrc from '../assets/aht-logo.png';
import butterflyIconSrc from '../assets/aht-butterfly.png';
import robertaPhotoSrc from '../assets/roberta.png';

export const navItems = {
  left: [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '/services' },
    { label: 'Healing Techniques', href: '/healing-techniques' },
  ],
  right: [
    { label: 'Blog', href: '/blog' },
    { label: 'Contact Us', href: '/contact' },
    { label: 'Policies', href: '/policies' },
    { label: 'Leave A Review', href: '/review' },
  ],
};

export const images = {
  butterfly: butterflyIconSrc,
  logo: butterflyLogoSrc,
  feelWell: 'https://customer-assets.emergentagent.com/job_energy-healing-react/artifacts/lnxd2d3s_feel-well2b.jpg',
  servicesImg: 'https://customer-assets.emergentagent.com/job_energy-healing-react/artifacts/zq6qk20q_services2.jpg',
  energyIcon: 'https://www.ahealingtouchenergy.com/wp-content/uploads/2019/12/energy-icon-150x150.png',
  oilsIcon: 'https://www.ahealingtouchenergy.com/wp-content/uploads/2019/12/oils-icon-150x150.png',
  reflexologyIcon: 'https://www.ahealingtouchenergy.com/wp-content/uploads/2019/12/reflexology-icon-150x150.png',
  roberta: robertaPhotoSrc,
  spaAmbiance: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=400&h=400&fit=crop',
};

export const heroData = {
  phone: '719.684-2180',
  cta: 'Call us to schedule an appointment!',
};

export const deserveWellData = {
  label: 'A Healing Touch',
  heading: 'You deserve to feel well',
  paragraphs: [
    'A Healing Touch Pain Release works in conjunction with healthcare providers to heal people who experience chronic pain, through non-invasive healing techniques.',
    'Simply stated, we are devoted to healing people who experience chronic pain. Roberta Millard, of A Healing Touch Pain Release, has an accumulation of 20+ years of education, experience, hard work, and dedication to becoming in tune to a gift of using quantum physics to shift and release pain.',
    'A Healing Touch Pain Release combines many traditional and alternative modalities to tap into the body\'s innate wisdom and response patterns.',
    'The effect is a gentle and effective treatment session with each individual and their own unique situation, which led them to our door.',
  ],
  buttonText: 'VIEW PACKAGES',
};

export const releasePainData = {
  scriptLabel: 'How we',
  heading: 'Release the pain',
  intro: 'A Healing Touch Pain Release combines the use of quantum physics (movement shifts on a subatomic level), learned physical techniques, and subtle-body energy methods.',
  sections: [
    {
      title: 'LIGHT & LOVE',
      text: 'We are surround by light and love. It is constantly and freely available to us, but we must clear space for it and invite it in. With energy healing, we find the sources of blockages and release and remove them and through pure intention fill your space up with light and love. When we are filled with light and love, healing can begin naturally to restore us to our natural center and state of wholeness.',
    },
    {
      title: 'VIRTUALLY PAIN FREE',
      text: 'Because everyone\'s situation is unique, each healing is different. Through spiritual guidance, many different techniques may be used to find, determine root cause, and restore balance to virtually eliminate pain. We work together to define goals to achieve wholeness and freedom to begin your journey to a virtually pain free life.',
    },
    {
      title: 'FREE TO LIVE AGAIN',
      text: 'You are the owner of your life and it may be difficult to see how beautiful you are and your life can be. Energy is pure love that many of us have wandered away from through the busyness of daily living and can be the reason we feel stuck, unbalanced, forgotten, unloved, or not even feel anything at all. Energy healing works to restore balance, peace, and self-love so that you can rediscover your true self and feel the freedom to live again.',
    },
  ],
  buttonText: 'LEARN MORE',
};

export const servicesData = {
  scriptLabel: 'What can we do?',
  heading: 'Our amazing services',
  services: [
    {
      icon: 'https://www.ahealingtouchenergy.com/wp-content/uploads/2019/12/energy-icon-150x150.png',
      iconType: 'flame',
      title: 'ENERGY WORK',
      description: 'Energetic Touch is a holistic, evidence based therapy that incorporates the science of quantum physics with the intentional and compassionate use of universal energy. Each treatment uses the practitioner as a conduit to a loving healing touch in order to release any pain and blocks in a person\'s body.',
    },
    {
      icon: 'https://www.ahealingtouchenergy.com/wp-content/uploads/2019/12/oils-icon-150x150.png',
      iconType: 'footprints',
      title: 'REFLEXOLOGY',
      description: 'With repeated practice of applying pressure and manipulating nerve endings (traditionally in the foot), reflexology can help clear any channels of blocked energy through moving the flow of blood, nutrients, and nerve impulses to ultimately improve overall health and balance.',
    },
    {
      icon: 'https://www.ahealingtouchenergy.com/wp-content/uploads/2019/12/reflexology-icon-150x150.png',
      iconType: 'droplets',
      title: 'CUSTOM OIL BLENDS',
      description: 'Custom oil blends can be used for managing various health issues and have been proven to change emotional states. In my practice, I use a \'grounding and release\', \'Joyful\' and \'Enlightenment\' blend. As an added bonus, they smell divine!',
    },
  ],
};

export const communityData = {
  scriptLabel: 'Reaching out',
  heading: 'Come join me!',
  intro: 'For those who need an extra special touch, Roberta is there lending a helping hand. Literally! And, she is happy to do so. Being able to help others find relief is what keeps Roberta going strong. Finding the relief they seek even as they walk away, is what keeps her patients coming back.',
  cards: [
    {
      title: 'HEALING WARRIORS',
      paragraphs: [
        'You can find Roberta helping America\'s veterans with CranioSacral therapy every fourth Saturday of each month for the Healing Warriors Program in Colorado Springs pop-up clinic.',
        'This therapy, among others, is provided for veterans and their families at the American Legion Post 209 on 3613 Jeannine Drive, Colorado Springs from 9 am - 1 pm.',
      ],
      linkText: 'LEARN MORE',
    },
    {
      title: 'THE OIL DIVA',
      paragraphs: [
        'Roberta has volunteered for 5 years at Pikes Peak Hospice & Palliative Care where she provides touch therapy for the inpatient unit and staff.',
        'She makes custom oil blends that work on an individual level of healing, comfort, peace and pain relief. Here, they call her The Oil Diva and her services are such a blessing.',
      ],
      linkText: 'LEARN MORE',
    },
  ],
};

export const testimonialsData = {
  scriptLabel: 'Testimonials',
  heading: 'We love our clients!',
  testimonials: [
    {
      text: "I am amazed by the healing I received from Roberta. She has extraordinary gifts and honestly I couldn't begin to explain how she does what she does! I felt like I was transported into a realm of profound relaxation and healing.",
      name: 'Sonya S.',
    },
    {
      text: 'I had a fantastic reflexology session with Roberta. She is so incredibly caring and compassionate. When I left, I felt calm, grounded, and relaxed. I would highly recommend you visit her today!',
      name: 'Karrie P.',
    },
    {
      text: "Roberta is amazing! Her grounded spirit resets and tones the people she touches. Her gifted, no-nonsense approach was welcomed.",
      name: 'Sherry M.',
    },
    {
      text: "Roberta is an gentle healer with a big heart! Whether she is doing energy work or custom oils, each treatment is tailored to the individual. She's truly amazing!",
      name: 'Amanda N.',
    },
  ],
  buttonText: 'MORE TESTIMONIALS',
};

export const aboutData = {
  scriptLabel: 'Something About Me',
  heading: 'Roberta Millard',
  buttonText: 'LEARN MORE',
};


// ==================== PAGE DATA ====================

export const servicesPageData = {
  scriptLabel: 'What we can do',
  heading: 'To help you feel your best',
  intro: 'A Healing Touch Pain Release works in conjunction with healthcare providers to heal people who experience chronic pain, through non-invasive healing techniques.',
  phone: '719.684-2180',
  phoneSubtext: 'to schedule your appointment and become virtually pain free!',
  packages: [
    {
      category: 'Energy Work',
      title: 'Healing Sessions',
      description: 'Energy Work packages consist of a personalized combination of Reiki, Craniosacral, Ortho-bionomy, Therapeutic Touch therapies.',
      virtualNote: 'VIRTUAL ENERGY HEALING sessions are now available!',
      options: [
        { name: 'Energy Work - Per Session', price: '$120' },
      ],
    },
  ],
};

export const techniquesPageData = {
  scriptLabel: 'A Healing Touch',
  heading: 'Energy Techniques',
  intro: "If you are experiencing reoccurring aches and pains, a spell of depression, going through a life change or simply feel 'stuck', you may find that the therapies provided below can help you achieve wholeness and well-being.",
  conditions: [
    'Fibromyalgia',
    'Neuropathy',
    'Plantar Fasciitis',
    'Body Pain',
    'Overall Health and Well-Being',
  ],
  techniques: [
    {
      title: 'ENERGETIC TOUCH',
      description: 'This ancient, non-invasive technique restores communication between cells coupled with the principles of quantum physics. An energetic touch is used to support and facilitate physical, emotional, mental and spiritual growth.',
    },
    {
      title: 'CRANIAL SACRAL',
      description: 'The goal is to release compression in the bones of the head, spinal column, and sacrum, which alleviates stress and pain. Practitioners use their hands to gently free up restrictions in the movement of cranial bones and associated soft tissues and to stimulate the flow of the cerebrospinal fluid.',
    },
    {
      title: 'REIKI',
      description: "Reiki can help ease tension, stress and can help support the body to facilitate an environment for healing on all levels physical, mental, and emotional. It feels pleasant, relaxing and is utilized for one's personal wellness.",
    },
    {
      title: 'PASSIVE SOMATIC RELEASE',
      description: 'Gentle movements and comfortable positioning, brief compression and subtle contact aids in recovery by reducing muscle tension, soothing the joints, increasing flexibility and range of movement, improving circulation and relaxing the entire body.',
    },
    {
      title: 'INTUITIVE HEALING',
      description: 'Over time, I have developed a sense of where there is an imbalance in the body and how to work with it. This is used in conjunction with the other modalities to form a personalized method customized to your needs.',
    },
    {
      title: 'BREATHWORK',
      description: 'From 20+ years of studying Yoga and Meditation, I have learned the art of Yoga Breath work (also known as Pranayama). I will customize conscious breathing to help you feel re-connected to the illuminating awareness that lays within you.',
    },
  ],
};

export const contactPageData = {
  scriptLabel: 'Reach Out to Us',
  heading: "We'd love to hear from you",
  intro: "Get in touch and we'll get back to you as soon as we can. We look forward to hearing from you!",
  phone: '(719) 684-2180',
  address: '2161 N Academy Blvd, Colorado Springs, CO 80909',
};

export const blogPageData = {
  scriptLabel: 'Our Blog',
  heading: 'Healing Insights',
  posts: [
    {
      slug: 'the-power-of-energy-healing',
      title: 'The Power of Energy Healing',
      date: 'March 15, 2025',
      excerpt: 'Discover how energy healing works on a subatomic level to restore balance and promote natural healing within your body. Learn about the science behind quantum physics and healing touch.',
      category: 'Energy Healing',
      content: [
        'Energy healing is one of the most profound and transformative modalities available to us today. At its core, energy healing works on the principle that everything in the universe is made up of energy — including our bodies. When this energy becomes blocked or imbalanced, it can manifest as physical pain, emotional distress, or spiritual disconnection.',
        'The science of quantum physics has shown us that at the subatomic level, particles can be influenced by intention and observation. This is the very foundation upon which energy healing operates. When a practitioner channels universal energy through their hands and into a client\'s body, they are working at the most fundamental level of matter to shift and release blockages.',
        'During an energy healing session, clients often report sensations of warmth, tingling, or a deep sense of relaxation. Some experience vivid imagery or emotional release. These are all signs that the energy is moving and the body is beginning to restore itself to its natural state of balance.',
        'At A Healing Touch Pain Release, we combine multiple energy modalities including Reiki, Therapeutic Touch, and Quantum Touch to create a personalized healing experience. Each session is unique because each person\'s energy field is unique.',
        'The beauty of energy healing is that it works in harmony with conventional medicine. It doesn\'t replace medical treatment — it enhances it. Many of our clients report faster recovery times, reduced pain, and an overall sense of well-being that supports their entire healing journey.',
        'If you\'re curious about energy healing, we invite you to experience it for yourself. Sometimes the most powerful healing begins with simply being open to the possibility that there is more to health and wellness than what meets the eye.',
      ],
    },
    {
      slug: 'understanding-chakra-balance',
      title: 'Understanding Chakra Balance',
      date: 'February 28, 2025',
      excerpt: 'Your chakras are energy centers that influence your physical, emotional, and spiritual well-being. Learn how to recognize imbalances and restore harmony through healing techniques.',
      category: 'Wellness',
      content: [
        'The chakra system is an ancient map of the human energy body that has been used for thousands of years in Eastern healing traditions. The word "chakra" comes from Sanskrit and means "wheel" or "circle" — referring to the spinning vortexes of energy that exist within our bodies.',
        'There are seven main chakras, each associated with specific physical, emotional, and spiritual functions. Starting from the base of the spine and moving upward, they are: the Root Chakra (security and grounding), Sacral Chakra (creativity and emotion), Solar Plexus Chakra (personal power), Heart Chakra (love and compassion), Throat Chakra (communication), Third Eye Chakra (intuition), and Crown Chakra (spiritual connection).',
        'When our chakras are open and balanced, energy flows freely through our bodies, and we experience physical health, emotional stability, and spiritual clarity. However, life experiences — trauma, stress, negative thought patterns — can cause chakras to become blocked or overactive.',
        'Signs of chakra imbalance can vary widely. A blocked Root Chakra might manifest as anxiety or financial worry. An imbalanced Heart Chakra could show up as difficulty in relationships or an inability to forgive. A blocked Throat Chakra might make it hard to express your truth.',
        'Energy healing techniques such as Reiki, crystal healing, and guided meditation can help restore chakra balance. During a healing session, a practitioner can sense which chakras are out of alignment and work to gently restore the flow of energy.',
        'You can also support your own chakra health through practices like yoga, meditation, spending time in nature, and conscious breathing. Each chakra responds to specific colors, sounds, and affirmations that can help maintain balance in your daily life.',
        'At A Healing Touch Pain Release, we incorporate chakra assessment and balancing into our healing sessions. Understanding your unique energy patterns is key to achieving lasting wellness and freedom from pain.',
      ],
    },
    {
      slug: 'essential-oils-for-pain-relief',
      title: 'Essential Oils for Pain Relief',
      date: 'February 10, 2025',
      excerpt: 'Custom oil blends can provide remarkable relief from chronic pain. Explore the therapeutic properties of essential oils and how they work with your body\'s natural healing processes.',
      category: 'Essential Oils',
      content: [
        'Essential oils have been used for thousands of years across cultures for their healing properties. These concentrated plant extracts carry the essence of the plant they come from — including powerful therapeutic compounds that can support pain relief, emotional balance, and overall wellness.',
        'At A Healing Touch Pain Release, we create custom oil blends tailored to each individual\'s unique needs. Our signature blends include "Grounding and Release" for those dealing with chronic pain and stress, "Joyful" for emotional upliftment, and "Enlightenment" for spiritual clarity and peace.',
        'How do essential oils work for pain relief? When applied topically or inhaled, the aromatic compounds in essential oils interact with your body\'s limbic system — the part of the brain that controls emotions, memories, and certain physiological functions. This is why certain scents can immediately change your mood or help you relax.',
        'Some of the most effective essential oils for pain management include lavender (for relaxation and inflammation), peppermint (for headaches and muscle tension), eucalyptus (for joint pain and respiratory support), and frankincense (for deep healing and spiritual connection).',
        'When combined with energy healing, essential oils can amplify the therapeutic effects of a session. The oils help the body relax more deeply, allowing the energy work to penetrate more effectively and the healing to take root at a deeper level.',
        'It\'s important to use high-quality, therapeutic-grade essential oils and to work with a knowledgeable practitioner who understands proper dilution and application methods. Custom blends should be created with intention and knowledge of how different oils interact.',
        'Whether you\'re dealing with chronic pain, emotional turbulence, or simply want to enhance your daily wellness routine, essential oils offer a natural, gentle, and effective path to feeling better. As an added bonus — they smell divine!',
      ],
    },
    {
      slug: 'breathwork-your-path-to-inner-peace',
      title: 'Breathwork: Your Path to Inner Peace',
      date: 'January 20, 2025',
      excerpt: 'Pranayama, the ancient art of yogic breathing, offers profound benefits for stress relief and emotional healing. Discover simple techniques you can practice at home.',
      category: 'Breathwork',
      content: [
        'Breath is life. It is the first thing we do when we enter this world and the last thing we do when we leave. Yet most of us spend our entire lives breathing unconsciously, never tapping into the profound healing power that conscious breathing can offer.',
        'Pranayama, the yogic art of breath control, has been practiced for over 5,000 years. The word comes from two Sanskrit roots: "prana" (life force or vital energy) and "ayama" (to extend or expand). Through conscious breathing practices, we can literally expand our life force energy.',
        'From 20+ years of studying Yoga and Meditation, I have learned that breathwork is one of the most accessible and powerful healing tools available. It costs nothing, requires no equipment, and can be practiced anywhere at any time.',
        'Here are some simple breathwork techniques you can try at home:\n\nDeep Belly Breathing: Place one hand on your belly and breathe deeply, feeling your belly rise and fall. This activates the parasympathetic nervous system and signals your body to relax.\n\nBox Breathing: Inhale for 4 counts, hold for 4 counts, exhale for 4 counts, hold for 4 counts. Repeat for several minutes. This technique is used by Navy SEALs to stay calm under pressure.\n\nAlternate Nostril Breathing: Using your thumb and ring finger, alternate closing each nostril while breathing. This balances the left and right hemispheres of the brain.',
        'The benefits of regular breathwork practice are extensive: reduced stress and anxiety, improved sleep quality, enhanced focus and mental clarity, better emotional regulation, increased energy and vitality, and a deeper connection to your inner self.',
        'During healing sessions at A Healing Touch Pain Release, I incorporate customized breathwork to help clients feel re-connected to the illuminating awareness that lays within them. When combined with energy work, conscious breathing creates a powerful synergy for healing.',
        'I encourage you to begin with just 5 minutes of conscious breathing each day. Find a quiet space, close your eyes, and simply observe your breath. Over time, you may be amazed at the transformations that this simple practice can bring to your life.',
      ],
    },
    {
      slug: 'craniosacral-therapy-explained',
      title: 'CranioSacral Therapy Explained',
      date: 'January 5, 2025',
      excerpt: 'CranioSacral therapy gently releases restrictions in the craniosacral system to improve the functioning of the central nervous system. Learn what to expect during a session.',
      category: 'Therapy',
      content: [
        'CranioSacral Therapy (CST) is a gentle, hands-on approach that releases tensions deep in the body to relieve pain and dysfunction and improve whole-body health and performance. It was pioneered and developed by osteopathic physician John E. Upledger following extensive scientific studies.',
        'The craniosacral system consists of the membranes and cerebrospinal fluid that surround and protect the brain and spinal cord. This system has its own rhythm — a gentle pulsing that can be felt throughout the body. When restrictions or imbalances occur in this system, it can affect the central nervous system and every other system in the body.',
        'During a CranioSacral session, the practitioner uses extremely light touch — about the weight of a nickel — to evaluate the craniosacral system by gently feeling various locations of the body. This allows them to detect restrictions and imbalances in the flow of cerebrospinal fluid.',
        'Once an area of restriction is identified, the practitioner uses delicate manual techniques to release those restrictions. The release allows the body to self-correct and restore its natural healing capacity. Clients often describe the experience as deeply relaxing, and many fall into a peaceful, meditative state.',
        'CranioSacral Therapy has been shown to be effective for a wide range of conditions including: migraines and headaches, chronic neck and back pain, stress and tension-related disorders, brain and spinal cord injuries, chronic fatigue, fibromyalgia, TMJ syndrome, and central nervous system disorders.',
        'At A Healing Touch Pain Release, Roberta incorporates CranioSacral Therapy as one of several modalities used during healing sessions. She also volunteers her CranioSacral skills at the Healing Warriors Program, helping America\'s veterans find relief from pain and trauma.',
        'What makes CranioSacral Therapy particularly powerful is its gentleness. There is no forceful manipulation or adjustment. The body is never pushed beyond its comfort level. Instead, the practitioner works with the body\'s own self-correcting mechanisms, creating an environment where healing can occur naturally.',
        'If you are experiencing chronic pain, stress, or simply feel that something is "off" in your body, CranioSacral Therapy may be the gentle yet profound approach you\'ve been looking for. We invite you to experience this transformative modality at A Healing Touch Pain Release.',
      ],
    },
  ],
};

export const policiesPageData = {
  scriptLabel: 'Our Policies',
  heading: 'Policies & Guidelines',
  policies: [
    {
      title: 'Cancellation Policy',
      content: 'We kindly request at least 24 hours notice for cancellations or rescheduling. Late cancellations or no-shows may be subject to a fee equal to 50% of the session cost. We understand that emergencies happen and will work with you on a case-by-case basis.',
    },
    {
      title: 'Payment Policy',
      content: 'Payment is due at the time of service. We accept cash, check, and major credit cards. Package payments are due in full at the time of purchase. Packages are non-refundable but may be transferred to another person.',
    },
    {
      title: 'Session Expectations',
      content: 'Please arrive 5-10 minutes before your scheduled appointment. For phone sessions, please be in a quiet, comfortable environment where you can fully relax. Wear comfortable clothing and stay hydrated before and after your session.',
    },
    {
      title: 'Confidentiality',
      content: 'All client information is kept strictly confidential. Your personal information, session details, and health history will never be shared with third parties without your written consent.',
    },
    {
      title: 'Scope of Practice',
      content: 'A Healing Touch Pain Release provides complementary healing services and does not diagnose, treat, or prescribe for medical conditions. Our services work in conjunction with, not as a replacement for, medical care from your healthcare provider.',
    },
  ],
};

export const reviewPageData = {
  scriptLabel: 'Share Your Experience',
  heading: 'Leave A Review',
  intro: 'Your feedback means the world to us! If you have experienced the healing touch of Roberta, we would love to hear about your journey. Your review helps others find their path to wellness.',
};
